/**
 * Suppression des doublons d'un tableau
 */
export function uniq<T>(list: T[]): T[] {
  return Array.from(new Set(list))
}
